module.exports = __webpack_public_path__ + "static/frequentlens-e2dc6e154e9eab487e0be70c698971d8.png";